import { AccountTransactionDetailModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../shared';
import { defaultAccountTransactionDetailModelDto } from '../data';

export class Transaction extends DomainEntity<AccountTransactionDetailModelDto> {
    constructor(public source: AccountTransactionDetailModelDto) {
        super(source);
    }

    public createDefault(): this {
        return new Transaction(defaultAccountTransactionDetailModelDto) as this;
    }

    public get id() {
        return this.source.id;
    }

    public get date() {
        return this.source.date;
    }

    public get description() {
        return this.source.description;
    }

    public get amount() {
        return (this.source.isDebit ? this.source.debit : this.source.credit) ?? 0;
    }

    public get isDebit() {
        return this.source.isDebit;
    }

    public get tranCodeDescription() {
        return this.source.tranCodeDescription;
    }

    public get tranCodeType() {
        return this.source.tranCodeType;
    }

    public get checkNumber() {
        return this.source.checkNumber;
    }

    public get checkImageNumber() {
        return this.source.checkImageNumber;
    }
}
